/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeDeliveryNotesInPool } from '../../models/consignee-delivery-notes-in-pool';
import { KeyType } from '../../models/key-type';
import { NameTypeNullAble } from '../../models/name-type-null-able';

export interface GetConsigneeAddonsDeliveryNotes$Params {
  organizationSiteKey: KeyType;
  orderNumber?: NameTypeNullAble;
}

export function getConsigneeAddonsDeliveryNotes(http: HttpClient, rootUrl: string, params: GetConsigneeAddonsDeliveryNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNotesInPool>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeAddonsDeliveryNotes.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('orderNumber', params.orderNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeDeliveryNotesInPool>;
    })
  );
}

getConsigneeAddonsDeliveryNotes.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes';
